import { PoolTask } from '../../tasks/models/pool-task-object.model';
import { SearchResult } from '../search/models/search-result.model';

/**
 * Represents a search result object of a PoolTask object
 */
export class PoolTaskSearchResult extends SearchResult<PoolTask> {
}
